import config from 'config';
import { Button, Text } from 'AppStyles';
import { Container } from './Styles';

const Banned = () => {
  const { redirector } = config;
  return (
    <Container>
      <Text>Seems like you are having problems logging into the store.</Text>
      <Text>Please contact support for help.</Text>
      <Button $isModal onClick={() => window.open(redirector)}>
        Back to the game
      </Button>
    </Container>
  );
};

export default Banned;
